import React from 'react';
import { useRecaptchaContext } from '../../../../../contexts/recaptcha';
import { useRegisterComponent } from '../../../../orchestrator';
import { CreateAccountConfirmationRecaptchaContainer } from './styled';

export const CreateAccountConfirmationRecaptcha = () => {
  useRegisterComponent(CreateAccountConfirmationRecaptcha.name);

  const { enabled: recaptchaEnabled, component: recaptchaComponent } = useRecaptchaContext();

  // TODO: confirm if server can tell this page to skip recaptcha by including a boolean flag in
  // the state, as it can for other pages (like Welcome)
  const shouldShow = recaptchaEnabled && recaptchaComponent;

  if (!shouldShow) {
    return null;
  }

  return (
    <CreateAccountConfirmationRecaptchaContainer>
      {recaptchaComponent}
    </CreateAccountConfirmationRecaptchaContainer>
  );
};
